import React from "react";

import { Link } from "../../../Link";
import { Text } from "../../../Text";
import { NotificationSection } from "../../../NotificationSection";

import "./styles.scss";
import { SUPPORT_NUMBER, SUPPORT_NUMBER_HREF } from "../../../../constants/aptihealth";

// Relates to: Profile Insurance Status

export const NotConfigured = ({ dateChecked }) => {
  return (
    <NotificationSection className="notConfigured">
      <Text className="bold mb-3">Your insurance info has changed.</Text>

      <Text>
        <>
          <div className="mb-3">
            We saved your new insurance info but had an issue checking your coverage.
          </div>
          <div className="mb-3">
            To prevent billing issues, please contact{" "}
            <Link href="mailto:support@aptihealth.com">support@aptihealth.com</Link> or{" "}
            <Link href={SUPPORT_NUMBER_HREF}>{SUPPORT_NUMBER}</Link> before your next appointment.
          </div>
          <div>Checked: {dateChecked}</div>
        </>
      </Text>
    </NotificationSection>
  );
};

NotConfigured.defaultProps = {
  dateChecked: "",
};
